//persian number to English Digits

const e2p = s => {

  if (s === undefined || s === 'undefined') {
    return undefined
  }
  s += ""
  return s.replace(/\d/g, d => '۰۱۲۳۴۵۶۷۸۹'[d])
}
const e2a = s => s.replace(/\d/g, d => '٠١٢٣٤٥٦٧٨٩'[d])
const p2e = (s) => s.replace(/[۰-۹]/g, (d) => '۰۱۲۳۴۵۶۷۸۹'.indexOf(d));
const a2e = s => s.replace(/[٠-٩]/g, d => '٠١٢٣٤٥٦٧٨٩'.indexOf(d))

const p2a = s => s.replace(/[۰-۹]/g, d => '٠١٢٣٤٥٦٧٨٩'['۰۱۲۳۴۵۶۷۸۹'.indexOf(d)])
const a2p = s => s.replace(/[٠-٩]/g, d => '۰۱۲۳۴۵۶۷۸۹'['٠١٢٣٤٥٦٧٨٩'.indexOf(d)])


const numeric = {
  e2p,
  e2a,
  p2e,
  a2e,
  p2a,
  a2p,

};

export default numeric;